/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

//import auth from '@/auth/authService'

import firebase from '@/services/saleData';
import 'firebase/auth';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            //component: () => import('./views/Dashboard.vue'),
            meta: {
              auth: true
            },
            children: [
              {
                path: '/',
                redirect: '/dashboard'
              },
              {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('./views/Dashboard.vue'),
                meta: {
                  rule: 'editor'
                }
              },
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/statement/manual',
                name: 'manual',
                component: () => import('./views/management/user-edit/UserEdit.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/pushbullet',
                name: 'pushbullet',
                component: () => import('./views/management/pushbullet/List.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/agent',
                name: 'agent',
                component: () => import('./views/management/agent-list/Agent.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/anoucement',
                name: 'anoucement',
                component: () => import('./views/management/report/Anoucement.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/site',
                name: 'site',
                component: () => import('./views/management/site/Site.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/master',
                name: 'master',
                component: () => import('./views/management/master-list/Master.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/user',
                name: 'user',
                component: () => import('./views/management/user-list/User.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/user2',
                name: 'user',
                component: () => import('./views/management/user-list/User2.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/userbank',
                name: 'userbank',
                component: () => import('./views/management/user-list/UserBank.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/user/:userId',
                name: 'app-user-view',
                component: () => import('./views/management/user-list/UserView.vue'),
                meta: {
                  auth: true,
                  parent: 'app-user-list',
                }
              },
              {
                path: '/management/user/form',
                name: 'user-create-form',
                component: () => import('./views/management/user-edit/UserEdit.vue'),
                meta: {
                  auth: true,
                  parent: 'app-user-list',
                }
              },
              {
                path: '/management/user/form/:userId',
                name: 'user-edit-form',
                component: () => import('./views/management/user-edit/UserEdit.vue'),
                meta: {
                  auth: true,
                  parent: 'app-user-list',
                }
              },
              {
                path: '/management/deposit',
                name: 'deposit',
                component: () => import('./views/management/deposit-list/Deposit.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-user',
                name: 'report-user',
                component: () => import('./views/management/report/User.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-deposit',
                name: 'report-deposit',
                component: () => import('./views/management/report/Deposit.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-withdraw',
                name: 'report-withdraw',
                component: () => import('./views/management/report/Withdraw.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-setcredit',
                name: 'report-setcredit',
                component: () => import('./views/management/report/SetCredit.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-register',
                name: 'report-register',
                component: () => import('./views/management/report/Register.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/return-user',
                name: 'return-user',
                component: () => import('./views/management/report/ReturnUser.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-bonus',
                name: 'report-bonus',
                component: () => import('./views/management/report/Bonus.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/redeem-user',
                name: 'redeem-user',
                component: () => import('./views/management/report/RedeemRewards.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/spin',
                name: 'spin',
                component: () => import('./views/management/report/Spin.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/spin-setting',
                name: 'spin-setting',
                component: () => import('./views/management/report/SpinSetting.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/roulet',
                name: 'roulet',
                component: () => import('./views/management/report/Roulet.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/roulet-setting',
                name: 'roulet-setting',
                component: () => import('./views/management/report/RouletSetting.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/huay',
                name: 'huay',
                component: () => import('./views/management/report/Huay.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/admin',
                name: 'admin',
                component: () => import('./views/management/report/Admin.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/promotion',
                name: 'promotion',
                component: () => import('./views/management/promotion/Promotion.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/cashback',
                name: 'cashback',
                component: () => import('./views/management/cashback/Cashback.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/partner',
                name: 'partner',
                component: () => import('./views/management/partner/Partner.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-partner',
                name: 'report-partner',
                component: () => import('./views/management/report/Partner.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-continue',
                name: 'report-continue',
                component: () => import('./views/management/report/Continue.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/report-master',
                name: 'report-master',
                component: () => import('./views/management/report/Master.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/line',
                name: 'line',
                component: () => import('./views/management/report/Line.vue'),
                meta: {
                  auth: true
                }
              },
              /*
              {
                path: '/management/role',
                name: 'role',
                component: () => import('./views/management/role-list/Role.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/role/form/:roleId',
                name: 'role-edit-form',
                component: () => import('./views/management/role-edit/RoleEdit.vue'),
                meta: {
                  auth: true,
                  parent: 'app-role-list',
                }
              },*/
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
      if (!firebase.auth().currentUser) {
          next({
              path: '/login'
          })
      } else {
          next()
      }
  } else {
      next()
  }
})
export default router
